import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Drawer, Dropdown, List, Spin, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { AiFillPlusCircle, AiOutlineQuestionCircle } from "react-icons/ai";
import { BiRefresh } from "react-icons/bi";
import { IoClose, IoWarningOutline } from "react-icons/io5";
import { LuUserRoundPlus } from "react-icons/lu";
import { MdMyLocation } from "react-icons/md";
import { PiSealCheck } from "react-icons/pi";
import { SlOptionsVertical } from "react-icons/sl";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { AssetsMiddleware } from "../../../../Store/Middlewares/AssetsMiddleware";
import { ScheduleMiddleware } from "../../../../Store/Middlewares/ScheduleMiddleware";
import dummyImg from "../../../../assets/images/dummy.png";
import imagePlaceholder from "../../../../assets/images/imageplace.jpg";
import md1 from "../../../../assets/images/staticImages/c1.png";
import md2 from "../../../../assets/images/staticImages/c2.png";
import md3 from "../../../../assets/images/staticImages/c3.png";
import md4 from "../../../../assets/images/staticImages/c4.png";
import md5 from "../../../../assets/images/staticImages/c5.png";
import {
  Dropdown as Drop,
  InputField,
  Modal,
  TextComponent,
} from "../../../../components";
import Card from "../../../../components/Card/Card";
import Switch from "../../../../components/Switch/Switch";
import BatteryStatus from "../../../../components/battery/Battery";
import FloatingButton from "../../../../components/floatingButton/FloatBtn";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import { extractBytes, hexToBase64 } from "../../../../utills";
import { validateEmail } from "../../../../utills/Validators";
import AddAssets from "../AddAssets/AddAssets";
import AddGroupAssetModal from "../AddGroupAsset/AddGroupAsset";
import EditAssets from "../EditAsset/EditAsset";
import EditScheduleModal from "../ScheduleModal/EditScheduleModal";
import ScheduleModal from "../ScheduleModal/ScheduleModal";
import TrackingModal from "../TrackingModal/TrackingModal";
import UploadAssets from "../UploadAsset/UploadAsset";
import styles from "./singleasset.module.css";

const SingleAssets = ({ add_asset, is_immobilized, user, setActiveTab }) => {
  ///schedule
  const getScheduleData = useSelector(
    (state) => state.ScheduleReducer.schedule,
  );

  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const [details, setDetails] = useState([]);
  const [moduledetails, setModuleDetails] = useState([]);
  const [open, setOpen] = useState(false);
  const [afterDispatch, setAfterDispatch] = useState(false);
  const [openAddAssetsModal, setOpenAddAssetsModal] = useState(false);
  const [openEditAssetsModal, setOpenEditAssetsModal] = useState(false);
  const [openAddGroupAsset, setOpenAddGroupAsset] = useState(false);
  const [openUploadAsset, setOpenUploadAsset] = useState(false);
  const [locationTracking, setLocationTracking] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [success, setSuccess] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [editScheduleModal, setEditScheduleModal] = useState(false);
  const [schedule, setScheduleData] = useState(null);
  const [accessEmail, setAccessEmail] = useState("");
  const [accessFirstName, setAccessFirstName] = useState("");
  const [accessLastName, setAccesslastName] = useState("");
  const [licenseDur, setLicenseDur] = useState("");
  const [accessSharingModal, setAccessSharingModal] = useState(false);
  const [soldModal, setSoldModal] = useState(false);
  const [accessSuccessModal, setAccessSuccessModal] = useState(false);
  const [accessDeniedModal, setAccessDeniedModal] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [activeButton, setActiveButton] = useState("percentage");
  const [checkBattery, setcheckBattery] = useState(false);

  /////////////////////////////////////////////////////For Battery/////////////////////////////////////////////////

  // const [checkBattery, setcheckBattery] = useState(false)
  // const chatchannel = useRef();

  // useEffect(() => {
  //   initiatePusher()
  //   return () => {
  //     if (chatchannel?.current) {
  //       chatchannel?.current?.unsubscribe();
  //     }
  //   }
  // }, [])

  // const initiatePusher = () => {
  //   chatchannel.current = pusher.subscribe('phoenix-immobilizer');
  //   chatchannel.current.bind('App\\Events\\TTNUpLink', data => {
  //     console.log('dataaaaaaa', data);

  // if (data?.data?.device_id == details?.device_id) {
  //   if (data?.data?.ascii_payload?.includes('BV')) {
  //     const match = data?.data?.ascii_payload.match(/BV:([0-9.]+)/);
  //     const bvValue = match ? match[1] : null;
  //     dispatch(AssetsMiddleware.updateBatteryVolt({ battery_volt: bvValue, asset_id: details?.id })).then(() => setcheckBattery(false))
  //   }
  // }
  //   });
  // };

  const ref = useRef();
  const SingleAssets = useSelector(
    (state) => state.AssetsReducer.getSingleAssets,
  );
  const setAssetsStatus = useSelector(
    (state) => state.AssetsReducer.setAssetsStatus,
  );
  const temporary_access = user?.permissions?.find(
    (x) => x?.name == "temporary_access",
  );
  const sell_through = user?.permissions?.find(
    (x) => x?.name == "sell_through",
  );
  const reports = user?.permissions?.find((x) => x?.name == "reports");
  const lot_name = user?.permissions?.find((x) => x?.name == "lot_name");

  const lot_numbers = useSelector((state) => state.PagesReducer?.lot_numbers);

  const getData = (name) => {
    dispatch(AssetsMiddleware.getSingleAssets(name)).then((data) => {});
  };
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!afterDispatch) setOpen(false);
  }, [!afterDispatch]);

  const onGetDetail = (id, moduleId) => {
    dispatch(AssetsMiddleware.getSingleAssetsDetails(id)).then((data) => {
      setDetails(data?.data?.data);
      setOpen(true);
    });
    dispatch(AssetsMiddleware.getModuleDetails(moduleId)).then((data) => {
      setModuleDetails(data?.data?.data);
    });
  };
  const getModuleData = (name) => {
    dispatch(AssetsMiddleware.getUnlinkModules(name)).then((data) => {});
  };
  const onClickSharing = () => {
    let userData = {
      email: accessEmail,
      assetId: details?.id,
      moduleId: moduledetails?.id,
      first_name: accessFirstName,
      last_name: accessLastName,
      type: soldModal ? "sold" : "temporary",
    };
    if (soldModal) {
      userData["license_key"] = details?.license_no;
      userData["license_duration"] = licenseDur;
    }

    if (!accessEmail || !accessFirstName || !accessLastName) {
      dispatch(
        showAlert({ type: "Error", message: "All fields are required" }),
      );
    } else {
      dispatch(AssetsMiddleware.dealerShareAccess(userData))
        .then(() => {
          setAccessSharingModal(false);
          setAccessSuccessModal(true);
          setOpen(false);
          setDetails([]);
          setAccessEmail("");
          setAccessFirstName("");
          setAccesslastName("");
          setSoldModal(false);
        })
        .catch(() => {
          setAccessDeniedModal(true);
        });
    }
  };
  const onClickImmobilized = () => {
    console.log(details.dev_eui);
    dispatch(
      AssetsMiddleware.sentDownlink({
        device_id: details?.device_id,
        action:
          setAssetsStatus?.status != "immobilized"
            ? hexToBase64(extractBytes(details.dev_eui) + "A1")
            : hexToBase64(extractBytes(details.dev_eui) + "A2"),
        status:
          setAssetsStatus?.status == "immobilized" ? "drive" : "immobilized",
        asset_id: details?.id,
      }),
    );
  };
  const onDeleteModuleFromAsset = () => {
    dispatch(AssetsMiddleware.deleteModuleFromAsset({ id: details?.id })).then(
      () => {
        setOpen(false);
        getModuleData();
      },
    );
  };
  const onExportAssest = async () => {
    await dispatch(AssetsMiddleware.exportAssets()).then((data) => {
      const url = data?.data?.data?.url;
      if (url) {
        window.open(url, "_blank");
      }
    });
  };
  const getBatteryVolt = () => {
    setcheckBattery(true);
    dispatch(
      AssetsMiddleware.sentDownlink({
        device_id: details?.device_id,
        action: hexToBase64(extractBytes(details.dev_eui) + "A5"),
        asset_id: moduledetails?.asset_id,
        status: details?.status,
      }),
    ).then(() => {
      setcheckBattery(false);
    });
  };
  const pagecalculation = () => {
    if (!SingleAssets?.meta) {
      return 0;
    }
    return (
      (SingleAssets?.meta?.current_page - 1) * SingleAssets?.meta?.per_page
    );
  };

  // dispatch(AssetsMiddleware.sentDownlink({ device_id: details?.device_id, action: hexToBase64(extractBytes(details.dev_eui) + 'A6'), status: 'immobilized', asset_id: assetsDetail?.id })).then(() => setstatus(true))
  //
  const items2 = [
    {
      key: "3",
      label: <a onClick={() => setOpenEditAssetsModal(true)}>Edit details</a>,
    },
    {
      key: "4",
      label: (
        <a
          onClick={() => {
            setOpen(false);
            setDeleteModal(true);
          }}
        >
          Delete asset
        </a>
      ),
    },
  ];

  const items1 = [
    {
      key: "1",
      label: <a onClick={onDeleteModuleFromAsset}>Disconnect</a>,
    },
  ];

  const scheduleData = [
    {
      title: "Immobilizer Activation",
      ferquency: "Daily",
      isImobilized: true,
      time: "10:00 AM",
    },
    {
      title: "High Security mode",
      ferquency: "Daily",
      isImobilized: false,
      time: "10:00 PM",
    },
    {
      title: "Immobilizer Health Check",
      ferquency: "Monday",
      isImobilized: true,
      time: "10:00 AM",
    },
  ];

  const renderItemScedule = (item) => {
    const items3 = [
      {
        key: "3",
        label: (
          <a
            onClick={() => {
              setEditScheduleModal(true);
              setScheduleData(item);
            }}
          >
            Edit Schedule
          </a>
        ),
      },
      {
        key: "4",
        label: (
          <a
            onClick={() =>
              dispatch(ScheduleMiddleware.deleteSchedule({ id: item?.id }))
            }
          >
            Delete
          </a>
        ),
      },
    ];
    return (
      <div className={`${styles.scheduleCont}`}>
        <div>
          <TextComponent text={item?.name} className={styles.heading} />
          <div className={styles.scheduleLeftCont}>
            {/* <TextComponent
              text={item?.frequency == "one_time" ? "One time" : "Daily"}
              className={styles.text}
            /> */}
            <TextComponent
              text={`${item?.start_time}-${item?.end_time}`}
              className={styles.scheduleTime}
            />
            <TextComponent
              text={`${item?.start_date ? item?.start_date + " to " + item?.end_date : ""}`}
              className={styles.scheduleTime}
            />
            {/* <TextComponent text= className={styles.scheduleTime} /> */}
            {/* <Switch
              isChecked={item.status == "active" ? true : false}
              size="small"
              // style={
              //   item.isImobilized
              //     ? { backgroundColor: "var(--primary-color)" }
              //     : { backgroundColor: "var(--green-color)" }
              // }
              onChange={() => {
                dispatch(
                  ScheduleMiddleware.updateScheduleStatus({ id: item?.id }),
                );
              }}
              // disabled
            /> */}
          </div>
        </div>
        <div className={styles.mobStatusCont}>
          <Dropdown
            trigger={"click"}
            menu={{
              items: items3,
            }}
            placement="bottomRight"
            arrow={{
              pointAtCenter: true,
            }}
          >
            <button className={styles.menubtn}>
              <SlOptionsVertical
                size={20}
                color="var(--light-text)"
                cursor={"pointer"}
              />
            </button>
          </Dropdown>
        </div>
      </div>
    );
  };
  const dummydata = [
    {
      id: 1,
      key: "01",
      module: { image: md1, name: "Honda" },
      version: "Accord LX",
      year: "2023",
      License_Plate: "HN-5KT832",
      vin: "4T1BF1FK6NU793459",
      track: <MdMyLocation className={styles.trackIcon} />,
    },
    {
      id: 2,
      key: "02",
      module: { image: md2, name: "Toyota" },
      version: "Camry SE",
      year: "2023",
      License_Plate: "HN-5KT832",
      vin: "4T1BF1FK6NU793459",
      track: <MdMyLocation className={styles.trackIcon} />,
    },

    {
      id: 3,
      key: "03",
      module: { image: md3, name: "Ford" },
      version: "F-150 XLT",
      year: "2023",
      License_Plate: "HN-5KT832",
      vin: "4T1BF1FK6NU793459",
      track: <MdMyLocation className={styles.trackIcon} />,
    },
    {
      id: 4,
      key: "04",
      module: { image: md4, name: "Chevrolet" },
      version: "Silverado LT",
      year: "2023",
      License_Plate: "HN-5KT832",
      vin: "4T1BF1FK6NU793459",
      track: <MdMyLocation className={styles.trackIcon} />,
    },
    {
      id: 5,
      key: "05",
      module: { image: md5, name: "Jeep" },
      version: "Wrangler Sport",
      year: "2023",
      License_Plate: "HN-5KT832",
      vin: "4T1BF1FK6NU793459",
      track: <MdMyLocation className={styles.trackIcon} />,
    },

    {
      id: 6,
      key: "06",
      module: { image: md3, name: "Nissan" },
      version: "Rogue S",
      year: "2023",
      License_Plate: " HN-5KT832",
      vin: "4T1BF1FK6NU793459",
      track: <MdMyLocation className={styles.trackIcon} />,
    },
  ];
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      render: (text, data, index) => (
        <div>
          <TextComponent
            text={`${pagecalculation() + index + 1}`}
            className={styles.versionText}
          />
        </div>
      ),
    },
    {
      title: "Pic",
      dataIndex: "image",
      key: "image",
      render: (item, data) => (
        <div className={styles.module}>
          <img
            src={data?.image ? data?.image : imagePlaceholder}
            className={styles.moduleImg}
          />
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (data) => (
        <div className={styles.module}>
          <TextComponent text={data ? data : "-"} className={styles.text} />
        </div>
      ),
    },
    {
      title: "Stock",
      dataIndex: "stock_no",
      key: "stock_no",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "VIN",
      dataIndex: "vin_no",
      key: "vin_no",
      render: (text) => {
        const lastEight = text ? text.toString().slice(-8) : "-";

        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={lastEight} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Make",
      dataIndex: "image",
      key: "image",
      render: (item, data) => (
        <div className={styles.module}>
          <TextComponent
            text={data?.make ? data?.make : "-"}
            className={styles.text}
          />
        </div>
      ),
    },

    {
      title: "Model",
      dataIndex: "model",
      key: "model",
      render: (text) => (
        <div>
          <TextComponent
            text={text ? text : "-"}
            className={styles.versionText}
          />
        </div>
      ),
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Odometer",
      dataIndex: "odometer",
      key: "odometer",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Day In Inventory",
      dataIndex: "days_in_inventory",
      key: "days_in_inventory",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Lot Name",
      dataIndex: "lot",
      key: "lot",
      render: (item, data) => {
        return (
          <div className={styles.carDiv} onClick={(e) => e.stopPropagation()}>
            <Drop
              value={data?.lot?.name}
              inputClass={styles.carDropDown}
              options={lot_numbers?.map((lot) => ({
                value: lot?.name,
                id: lot?.id,
              }))}
              onChange={(e) => {
                console.log(e);

                dispatch(
                  AssetsMiddleware.updateAssetLot({
                    lot_id: e?.id,
                    id: data?.id,
                  }),
                );
              }}
              disabled={
                (lot_name == undefined || lot_name?.is_access == 0) &&
                !user?.is_owner
              }
            />
          </div>
          // <div className={styles.dealerDiv}>
          //   <TextComponent
          //     text={data?.lot?.name ? data?.lot?.name : "-"}
          //     className={styles.text}
          //   />
          // </div>
        );
      },
    },
    // {
    //   title: "Year",
    //   dataIndex: "year",
    //   key: "battery",
    //   render: (text) => (
    //     <div className={styles.batteryDiv}>
    //       {/* <img src={item?.image} className={styles.moduleImg} /> */}
    //       {/* <BatteryStatus percentage={text} /> */}
    //       <TextComponent text={text} className={styles.text} />
    //     </div>
    //   ),
    // },
    {
      title: "License Plate",
      dataIndex: "license_no",
      key: "license_no",
      render: (text) => (
        <div className={styles.carDiv}>
          <TextComponent text={text ? text : "-"} className={styles.text} />
        </div>
      ),
    },

    {
      title: "Trim",
      dataIndex: "trim",
      key: "trim",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text ? text : "-"} className={styles.text} />
          </div>
        );
      },
    },

    // {
    //   title: "Track",
    //   dataIndex: "track",
    //   key: "track",
    //   render: (text) => (
    //     <div
    //       className={styles.trackDiv}
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         // setLocationTracking(true);
    //       }}
    //     >
    //       {text}
    //     </div>
    //   ),
    // },
  ];
  const baseButtons = [
    {
      title: "Add vehicle",
      onClick: () => setOpenAddAssetsModal(true),
    },
    {
      title: "Upload vehicle",
      onClick: () => setOpenUploadAsset(true),
    },
  ];

  const buttons =
    reports?.is_access === 0
      ? baseButtons
      : [
          ...baseButtons,
          {
            title: "Export vehicle",
            onClick: onExportAssest,
          },
        ];
  return (
    <>
      <div className={styles.tableHeader}>
        {user?.is_owner || add_asset?.is_access == 1 ? (
          <FloatingButton
            Buttons={buttons}
            floatStyle={styles.floatingBtn}
            buttonStyles={styles.floatingButtonsContainer}
          />
        ) : null}
      </div>
      <div className={styles.tableDiv}>
        <Table
          //   title={}
          scroll={{ x: true }}
          bordered={false}
          pagination={{
            showSizeChanger: false,
            showQuickJumper: false,
            current: SingleAssets?.meta?.current_page,
            pageSize: SingleAssets?.meta?.per_page,
            total: SingleAssets?.meta?.total,
            onChange: (page, pageSize) => {
              dispatch(
                AssetsMiddleware.getSingleAssets({
                  url: `${SingleAssets?.meta?.path}?page=${page}`,
                }),
              );
            },
            itemRender: (_, type, originalElement) => {
              if (type === "prev") {
                return (
                  <span
                    style={{
                      color: SingleAssets?.links?.prev ? "inherit" : "#ccc",
                      cursor: SingleAssets?.links?.prev
                        ? "pointer"
                        : "not-allowed",
                    }}
                    onClick={() => {
                      dispatch(
                        AssetsMiddleware.getSingleAssets({
                          // name: search,
                          url: SingleAssets?.links?.prev,
                        }),
                      );
                    }}
                  >
                    <LeftOutlined /> Prev
                  </span>
                );
              }
              if (type === "next") {
                return (
                  <span
                    style={{
                      color: SingleAssets?.links?.next ? "inherit" : "#ccc",
                      cursor: SingleAssets?.links?.next
                        ? "pointer"
                        : "not-allowed",
                    }}
                    onClick={() => {
                      dispatch(
                        AssetsMiddleware.getSingleAssets({
                          // name: search,
                          url: SingleAssets?.links?.next,
                        }),
                      );
                    }}
                  >
                    Next <RightOutlined />
                  </span>
                );
              }
              return originalElement;
            },
          }}
          columns={columns}
          dataSource={SingleAssets?.data}
          onRow={(record, rowIndex) => {
            return {
              onClick: () => onGetDetail(record?.id, record?.module_id),
              style: { cursor: "pointer" },
            };
          }}
        />

        {/* {width > 550 ? ( */}
        {/* {user?.is_owner || add_asset?.is_access == 1 ? (
          <FloatingButton Buttons={buttons} />
        ) : null} */}
        {/* ) : (
      <div className={styles.addNewResponsiveBtn}>
        <FaCirclePlus size={60} style={{ marginRight: "5px" }} />
      </div>
    )} */}
        <AddAssets
          isOpen={openAddAssetsModal}
          setIsOpen={setOpenAddAssetsModal}
          setActiveTab={setActiveTab}
        />
        <EditAssets
          isOpen={openEditAssetsModal}
          setIsOpen={setOpenEditAssetsModal}
          details={details}
          afterDispatch={setAfterDispatch}
          setDrawerState={setOpen}
        />
        <AddGroupAssetModal
          isOpen={openAddGroupAsset}
          setIsOpen={setOpenAddGroupAsset}
        />
        <TrackingModal
          locationTracking={locationTracking}
          setLocationTracking={setLocationTracking}
          // assets={[1,2,3,4]}
        />
        <ScheduleModal
          scheduleModal={scheduleModal}
          setScheduleModal={setScheduleModal}
          details={details}
          afterDispatch={setAfterDispatch}
        />
        <EditScheduleModal
          scheduleModal={editScheduleModal}
          setScheduleModal={setEditScheduleModal}
          afterDispatch={setAfterDispatch}
          details={details}
          scheduleData={schedule}
        />
        <UploadAssets
          isOpen={openUploadAsset}
          setIsOpen={setOpenUploadAsset}
          afterDispatch={setAfterDispatch}
        />
        <Modal
          open={deleteModal}
          onCancel={() => {
            setDeleteModal(false);
          }}
          icon={
            <AiOutlineQuestionCircle
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          }
          twoButton
          okBtnTitle={"Yes, delete"}
          cancelBtnTitle={"No, go back"}
          title={"Are you sure"}
          text={"You want to delete this vehicle?"}
          width={400}
          // btnDiv={styles.access_modalBtn}
          onClickCancelButton={() => {
            setDeleteModal(false);
          }}
          onClickOkButton={() => {
            dispatch(AssetsMiddleware.deleteAssets(details?.id)).then(() => {
              setDeleteModal(false);
              setSuccess(true);
            });
          }}
          headingClass={styles.modalHeading}
        ></Modal>
        <Modal
          open={success}
          onCancel={() => setSuccess(false)}
          icon={
            <PiSealCheck
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          }
          title={"vehicle Deleted successfully"}
          width={"300px"}
          buttonTitle={"Continue"}
          onBtnPress={() => {
            setSuccess(false);
          }}
          headingClass={styles.modalHeading}
        ></Modal>

        <Drawer
          width={width < 550 ? "100%" : 600}
          headerStyle={{ display: "none" }}
          onClose={() => {
            setOpen(false);
            setDetails([]);
          }}
          open={open}
        >
          {/* <div className={styles.drawerImgDiv}> */}
          {/* <img src={c6} className={styles.drawerImg} /> */}
          <div
            className={styles.crossIconDiv}
            onClick={() => {
              setOpen(false);
              setDetails([]);
            }}
          >
            <IoClose />
            {/* </div> */}
          </div>
          <div className={styles.rightCol}>
            <Card>
              <img
                src={details?.image || imagePlaceholder}
                alt=""
                className={styles.slectedImg}
              />
              <div className={styles.leftHeader}>
                <div>
                  {details?.name && (
                    <TextComponent
                      text={`${details?.name ? details?.name : "-"}`}
                      className={styles.heading}
                    />
                  )}
                  {details?.make && (
                    <TextComponent
                      text={`${details?.make ? details?.make : "-"} `}
                      className={styles.heading}
                    />
                  )}
                  {details?.license_no && (
                    <TextComponent
                      text={`License Plate: ${details?.license_no}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.vin_no && (
                    <TextComponent
                      text={`VIN: ${details?.vin_no}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.model && (
                    <TextComponent
                      text={`Model: ${details?.model}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.lot?.name && (
                    <TextComponent
                      text={`Lot Name: ${details?.lot?.name}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.dealer_name && !user?.is_owner && (
                    <TextComponent
                      text={`Dealer Name: ${details?.dealer_name}`}
                      className={styles.carDescText}
                    />
                  )}
                  {/* <TextComponent text={"2016"] className={styles.carDescText} /> */}
                  {/* <TextComponent
                  text={"Location: Lot A, Row 5"}
                  className={styles.carDescText}
                /> */}
                </div>
                <div>
                  {details?.color && (
                    <TextComponent
                      text={`Color: ${details?.color}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.trim && (
                    <TextComponent
                      text={`Trim: ${details?.trim}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.stock_no && (
                    <TextComponent
                      text={`Stock No: ${details?.stock_no}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.year && (
                    <TextComponent
                      text={`Year: ${details?.year}`}
                      className={styles.carDescText}
                    />
                  )}
                </div>
                {user?.is_owner || add_asset?.is_access == 1 ? (
                  <div>
                    <Dropdown
                      trigger={"click"}
                      menu={{
                        items: items2,
                      }}
                      placement="bottomRight"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <button className={styles.menubtn}>
                        <SlOptionsVertical
                          size={20}
                          color="var(--light-text)"
                          cursor={"pointer"}
                        />
                      </button>
                    </Dropdown>
                  </div>
                ) : null}
              </div>
            </Card>

            <Card className={styles.card}>
              <div className={styles.leftHeader}>
                <div>
                  <TextComponent
                    text={details?.device_name}
                    className={styles.heading}
                  />
                  <TextComponent
                    text={"Connected via LoRaWAN"}
                    className={styles.carDescText}
                  />
                  <TextComponent
                    text={details?.device_id}
                    className={styles.carDescText}
                  />
                  <div className={styles.showbatterydiv}>
                    <TextComponent
                      text={"Show Battery in"}
                      className={styles.carDescText}
                    />
                    <div className={styles.buttonsbattery}>
                      <button
                        style={{
                          background:
                            activeButton == "percentage"
                              ? "var(--green-color)"
                              : "var(--light-grey)",
                        }}
                        onClick={() => setActiveButton("percentage")}
                      >
                        Percentage
                      </button>
                      <button
                        style={{
                          background:
                            activeButton == "volt"
                              ? "var(--green-color)"
                              : "var(--light-grey)",
                        }}
                        onClick={() => setActiveButton("volt")}
                      >
                        Volt
                      </button>
                    </div>
                  </div>

                  <div className="flex-start">
                    {activeButton == "percentage" ? (
                      <BatteryStatus
                        percentage={parseFloat(
                          details?.battery_volt
                            ? (details?.battery_volt / 12) * 100
                            : (12 / 12) * 100,
                        ).toFixed(0)}
                      />
                    ) : (
                      <TextComponent
                        text={`Battery
                      ${
                        details?.battery_volt
                          ? details?.battery_volt + "V"
                          : "12V"
                      }`}
                      />
                    )}
                    <div style={{ marginLeft: "10px" }}>
                      {checkBattery ? (
                        <Spin
                          size="small"
                          style={{ color: "var(--secondary-color)" }}
                        />
                      ) : (
                        <BiRefresh
                          size={20}
                          style={{ cursor: "pointer" }}
                          onClick={getBatteryVolt}
                        />
                      )}
                    </div>
                  </div>

                  <div className={styles.scheduleLeftCont}>
                    {user?.is_owner || is_immobilized?.is_access == 1 ? (
                      <Switch
                        isChecked={
                          setAssetsStatus?.status == "immobilized"
                            ? true
                            : false
                        }
                        size="small"
                        onChange={onClickImmobilized}
                      />
                    ) : null}
                    <TextComponent
                      text={
                        setAssetsStatus?.status == "immobilized"
                          ? "Immobilized"
                          : "Drive"
                      }
                      className={styles.text}
                    />
                  </div>
                </div>
                {(user?.is_owner || add_asset?.is_access == 1) &&
                !details?.group ? (
                  <div>
                    <Dropdown
                      trigger={"click"}
                      menu={{
                        items: items1,
                      }}
                      placement="bottomRight"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <button className={styles.menubtn}>
                        <SlOptionsVertical
                          size={20}
                          color="var(--light-text)"
                          cursor={"pointer"}
                        />
                      </button>
                    </Dropdown>
                  </div>
                ) : null}
              </div>
            </Card>

            {/* {details?.group === null && ( */}
            <div className={styles.AccessDiv}>
              {details?.group === null ? (
                <>
                  <TextComponent
                    style={{
                      fontFamily: "Urbanist-bold",
                      fontSize: "var(--paragraph-font-size)",
                    }}
                    text={"Access details"}
                  />
                  {moduledetails?.shared_access == null ? (
                    temporary_access?.is_access == 0 &&
                    sell_through?.is_access == 0 ? null : (
                      <div className={styles.Access_Owner}>
                        <TextComponent
                          style={{ color: "var( --light-text)" }}
                          text={`Owner: ${"You"}`}
                        />
                        <div>
                          {(user?.is_owner ||
                            temporary_access?.is_access == 1) && (
                            <TextComponent
                              onClick={() => {
                                if (!moduledetails?.asset_id) {
                                  dispatch(
                                    showAlert({
                                      type: "Error",
                                      message: "Can't found asset",
                                    }),
                                  );
                                } else {
                                  setAccessSharingModal(true);
                                }
                              }}
                              className={styles.access_sharedBtn}
                              text={"Share Temporary Access"}
                            />
                          )}

                          {(user?.is_owner || sell_through?.is_access == 1) && (
                            <TextComponent
                              onClick={() => {
                                if (!moduledetails?.asset_id) {
                                  dispatch(
                                    showAlert({
                                      type: "Error",
                                      message: "Can't found asset",
                                    }),
                                  );
                                } else {
                                  setSoldModal(true);
                                }
                              }}
                              className={styles.access_sharedBtn}
                              text={"Sell Through"}
                            />
                          )}
                        </div>
                      </div>
                    )
                  ) : (
                    // <>
                    //   <List
                    //     className={styles.access_list}
                    //     dataSource={dummySharedAccess}
                    //     renderItem={(item, index) => (
                    <div className={styles.access_listItem}>
                      <div className={styles.access_listLeft}>
                        <img
                          src={
                            moduledetails?.shared_access?.profile_picture
                              ? moduledetails?.shared_access?.profile_picture
                              : dummyImg
                          }
                        />
                        <TextComponent
                          style={{
                            fontSize: "var(--mobile-heading)",
                            fontFamily: "Urbanist-semibold",
                          }}
                          text={
                            moduledetails?.shared_access?.email
                              ? moduledetails?.shared_access?.email
                              : ""
                          }
                        />
                      </div>
                      <div
                        className={styles.access_remove}
                        onClick={() => {
                          dispatch(
                            AssetsMiddleware.dealerRemoveAccess({
                              assetId: moduledetails?.asset_id,
                              userId: moduledetails?.shared_access?.id,
                            }),
                          ).then(() => setOpen(false));
                        }}
                      >
                        <TextComponent text={"Remove"} />
                      </div>
                    </div>
                    //     )}
                    //   />
                    // </>
                  )}
                </>
              ) : (
                <div className={styles.Access_Owner}>
                  <TextComponent
                    style={{ color: "var(--paragraph-font-size)" }}
                    text={`Group Name: ${details?.group?.name}`}
                  />
                </div>
              )}
            </div>
            {/* )} */}

            <Card className={styles.card}>
              <div className={styles.header}>
                <TextComponent text={"Schedule"} className={styles.heading} />
                {user?.is_owner || add_asset?.is_access == 1 ? (
                  <div
                    className={styles.btnScedule}
                    onClick={() => setScheduleModal(true)}
                  >
                    <TextComponent text={"Add"} />
                    <AiFillPlusCircle
                      size={18}
                      style={{ marginLeft: "5px" }}
                      color="var(--primary-color)"
                    />
                  </div>
                ) : null}
              </div>
              {/* {details?.schedules.length != 0 &&  */}
              <List
                dataSource={
                  getScheduleData?.length != 0
                    ? getScheduleData
                    : details?.schedules
                }
                renderItem={renderItemScedule}
              />
              {/* } */}
            </Card>
          </div>
        </Drawer>
        {/* /////////////////////////Access Sharing///////////////////////// */}

        <Modal
          open={accessSharingModal}
          onCancel={() => setAccessSharingModal(false)}
          imageClass={styles.access_modalImg}
          icon={
            <LuUserRoundPlus
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          }
          title={"Temporary Access Sharing"}
          width={"500px"}
          twoButton
          okBtnTitle={"Share"}
          cancelBtnTitle={"Go back"}
          btnDiv={styles.access_modalBtn}
          onClickCancelButton={() => setAccessSharingModal(false)}
          onClickOkButton={onClickSharing}
          buttonDisabled={emailError !== ""}
        >
          <div className={styles.access_modalBox}>
            <div
              style={{
                width: "90%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <InputField
                style={{ width: "49%" }}
                label={"First Name"}
                value={accessFirstName}
                onChange={(e) => setAccessFirstName(e.target.value)}
                placeholder={"Write here..."}
              />
              <InputField
                style={{ width: "49%" }}
                label={"Last Name"}
                value={accessLastName}
                onChange={(e) => setAccesslastName(e.target.value)}
                placeholder={"Write here..."}
              />
            </div>

            <InputField
              className={styles.access_modalInput}
              label={"Email"}
              value={accessEmail}
              // onChange={(e) => setAccessEmail(e.target.value)}
              placeholder={"chris@email.com"}
              onChange={(e) => {
                setAccessEmail(e.target.value);

                // live validation
                if (!e.target.value) {
                  setEmailError("Email is required");
                } else if (!validateEmail(e.target.value)) {
                  setEmailError("Enter a valid email address");
                } else {
                  setEmailError("");
                }
              }}
              error={emailError}
              type="email"
            />
            {/* <Dropdown
            label={"License Duration"}
            className={styles.access_modalInput}
            value={licenseDur ? licenseDur : "Select Duration"}
           
            onChange={(e)=>setLicenseDur(e?.value)}
            options={[{ id: 1, value: "3 years" }, { id: 1, value: "5 years" }]}
          /> */}
          </div>
        </Modal>
        <Modal
          open={soldModal}
          onCancel={() => setSoldModal(false)}
          imageClass={styles.access_modalImg}
          icon={
            <LuUserRoundPlus
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          }
          title={"Sold Device"}
          width={"500px"}
          twoButton
          okBtnTitle={"Sold"}
          cancelBtnTitle={"Go back"}
          btnDiv={styles.access_modalBtn}
          onClickCancelButton={() => setSoldModal(false)}
          onClickOkButton={onClickSharing}
          buttonDisabled={emailError !== ""}
        >
          <div className={styles.access_modalBox}>
            -
            <div
              style={{
                width: "90%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <InputField
                style={{ width: "49%" }}
                label={"First Name"}
                value={accessFirstName}
                onChange={(e) => setAccessFirstName(e.target.value)}
                placeholder={"Write here..."}
              />
              <InputField
                style={{ width: "49%" }}
                label={"Last Name"}
                value={accessLastName}
                onChange={(e) => setAccesslastName(e.target.value)}
                placeholder={"Write here..."}
              />
            </div>
            <InputField
              className={styles.access_modalInput}
              label={"Email"}
              value={accessEmail}
              // onChange={(e) => setAccessEmail(e.target.value)}
              placeholder={"chris@email.com"}
              onChange={(e) => {
                setAccessEmail(e.target.value);

                // live validation
                if (!e.target.value) {
                  setEmailError("Email is required");
                } else if (!validateEmail(e.target.value)) {
                  setEmailError("Enter a valid email address");
                } else {
                  setEmailError("");
                }
              }}
              error={emailError}
              type="email"
            />
            <Drop
              label={"License Duration"}
              className={styles.access_modalInput}
              value={licenseDur ? licenseDur : "Select Duration"}
              onChange={(e) => setLicenseDur(e?.value)}
              options={[
                { id: 1, value: "1 years" },
                { id: 1, value: "3 years" },
                { id: 1, value: "5 years" },
                { id: 1, value: "7 years" },
              ]}
            />
          </div>
        </Modal>

        {/* /////////////////////////Access Successfull///////////////////////// */}

        <Modal
          open={accessSuccessModal}
          onCancel={() => setAccessSuccessModal(false)}
          icon={
            <PiSealCheck
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          }
          title={"Access Shared successfully"}
          width={"400px"}
          buttonTitle={"Continue"}
          onBtnPress={() => {
            setAccessSuccessModal(false);
          }}
          headingClass={styles.modalHeading}
        ></Modal>

        {/* /////////////////////////Unable to access///////////////////////// */}

        <Modal
          open={accessDeniedModal}
          onCancel={() => setAccessDeniedModal(false)}
          icon={
            <IoWarningOutline
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          }
          title={"Unable to  Share Access!"}
          text={" Email not found: k.r.mastrangelo@outlook.com"}
          width={"400px"}
          buttonTitle={"Go back"}
          onBtnPress={() => setAccessDeniedModal(false)}
          // headingClass={styles.modalHeading}
        ></Modal>
      </div>
    </>
  );
};

export default SingleAssets;
